import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
	selector: 'app-recupera-password',
	imports: [FormsModule],
	templateUrl: './recupera-password.component.html',
})
export class RecuperaPasswordComponent {
	router = inject(Router);
	authService = inject(AuthService);

	username = signal('');
	loading = signal(false);
	success = signal(false);
	error = signal(false);
	errorMessage = signal('');

	resetPassword() {
		if (!this.username()) return;
		this.loading.set(true);
		this.success.set(false);
		this.error.set(false);
		this.errorMessage.set('');

		this.authService.resetPassword(this.username()).subscribe({
			next: () => {
				this.loading.set(false);
				this.success.set(true);
			},
			error: (err) => {
				this.loading.set(false);
				this.error.set(true);
				this.errorMessage.set(err.error || 'Utente non valido');
			},
		});
	}

	goToLogin() {
		const isWeb = this.router.url.includes('/web/');
		this.router.navigate([isWeb ? '/web/public/login' : '/app/public/login']);
	}
}
